import { OptimizelyProvider } from '@optimizely/react-sdk';
import { UserAttributes } from '@optimizely/optimizely-sdk';
import { optimizelyReadyTimeoutMs } from './optimizely';

interface AppOptimizelyProviderProps {
  children: JSX.Element;
  /**
   * The signed-in member. Omit on pre-auth screens (login/sign up), where flags
   * are legitimately evaluated without a user.
   */
  user?: {
    id: string;
    attributes?: UserAttributes;
  };
}

/**
 * Wraps `OptimizelyProvider` with the app-wide configuration every call site
 * needs — the shared client instance and the ready timeout — so those cannot
 * drift apart between the several places the provider is mounted.
 *
 * Falls through to `children` when no client was created, so a missing SDK key
 * degrades to "flags off" instead of crashing the tree.
 */
export function AppOptimizelyProvider({ children, user }: AppOptimizelyProviderProps) {
  if (!global.optimizely) {
    return children;
  }

  return (
    <OptimizelyProvider
      optimizely={global.optimizely}
      timeout={optimizelyReadyTimeoutMs}
      user={user}
    >
      {children}
    </OptimizelyProvider>
  );
}
